'use strict';

var base = require('./base');
var detail = require('base/product/detail');
var tile = require('./tile.js');
var customUtil = require('../customUtil.js');
var sitevibes = require('./siteVibes.js');
const debounce = require("lodash/debounce");

const PRIMARY_CAROUSEL_CLASS = base.PRIMARY_CAROUSEL_CLASS;
const THUMB_CAROUSEL_CLASS = base.THUMB_CAROUSEL_CLASS;
const PRODUCT_ERROR_CLASS = 'product-detail-error';



// NEW FUNCTIONALITY: 
// Creates new listeners
/**
 * Handles disabled click alert messaging
 * @param {string} message - The alert message
 */
function disabledAlert($element, message) {
    if ($element.find(`.${PRODUCT_ERROR_CLASS}`).length === 0) {
        var $message = $('<div/>').attr({
            'class': PRODUCT_ERROR_CLASS
        }).html(message);
        $element.append($message);
    }
}

function clearErrors() {
    $(`.${PRODUCT_ERROR_CLASS}`).remove();
}

/**
 * Adds disabled button click listeners
 */
function disableAlerts() {
    $(document).on('click', '.cart-and-ipay:has(.add-to-cart.disabled), .cart-and-ipay:has(.add-to-cart[disabled])', function (e) {
        disabledAlert($(this).closest('.product-detail').find('.attribute-container .attribute'), $('.add-to-cart').data('disabledMsg'));
    });

    $(document).on('click', '.custom-quantity-input:has(.btn-increase-quantity.disabled)', function (e) {
        disabledAlert($(this).closest('.simple-quantity'), $(this).find('.btn-increase-quantity').data('disabledMsg'));
    });

    $('body').on('product:afterAddToCart', clearErrors);

    $('body').on('product:afterAttributeSelect', clearErrors);
}

/**
 * Initializes primary and thumb image carousels
 */
function slickSliderInit() {
    if (customUtil.isMobile()) {
        $(PRIMARY_CAROUSEL_CLASS).slick({
            dots: true,
        });

        $(PRIMARY_CAROUSEL_CLASS).on('afterChange', function (_event, _slick, currentSlide) {
            var $targetSlide = $(THUMB_CAROUSEL_CLASS).find(`.thumb-container`)[currentSlide];
            $(THUMB_CAROUSEL_CLASS).find(`.thumb-container`).removeClass('slick-current');
            $($targetSlide).addClass('slick-current');
        });

        $(THUMB_CAROUSEL_CLASS).find(`.thumb-container`).on('click', function () {
            var index = $(this).index();
            $(PRIMARY_CAROUSEL_CLASS).slick('slickGoTo', index);
        });
    }
}

/**
 * Handles mobile carousel reload
 */
function pdpImageCarousel() {


    $(window).on('load', slickSliderInit);

    $(window).on('load', initForceNoFocus);

    $(window).on('resize', debounce(slickSliderInit, 50));

    $('body').on('product:afterAttributeSelect', slickSliderInit);
}

/**
 * Toggles share dropdown
 */
function toggleShare() {
    $(document).on('click', '.social-sharing-button, .social-sharing-close', function () {
        $(this).closest('.dropdown, .dropdown-menu').toggleClass('show');
        $(this).siblings('.dropdown-menu').toggleClass('show');
        if ($(this).is('[aria-expanded]')) {
            $(this).attr('aria-expanded', $(this).closest('.dropdown').hasClass('show'));
        }
    });
}

/**
 * Toggles ATC disabled class
 * Updating to use class instead of attribute (attribute 'disabled' does not allow click events)
 * @param {Boolean} disable - Determines if btn needs to be disabled
 */
function updateAddToCartEnableDisableOtherElements(disable) {
    $('button.add-to-cart-global, button.add-to-cart').toggleClass('disabled', disable);
}

// CUSTOM FUNCTIONALITY:
// Replaces OOTB listeners

function availability() {
    $(document).on('click', '.product-detail .btn-change-quantity', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.product-detail');
        var $qtySelector = $('.quantity-select');
        var currentValue = parseInt($qtySelector.val());
        var maxValue = parseInt($qtySelector.data('max-qty'));
        var oldUrl = $qtySelector.data('url');
        var withoutQty = oldUrl.split('&quantity=')[0];
        var newValue = +currentValue;
        if ($(this).hasClass('btn-increase-quantity') && maxValue < 100 && maxValue > currentValue) {
            newValue += 1;
        }
        if ($(this).hasClass('btn-decrease-quantity') && currentValue > 1) {
            newValue -= 1;
        }
        if ($(this).hasClass('btn-decrease-quantity') && currentValue == 1) {
            return;
        }
        $(this).closest('.product-detail').find('.btn-decrease-quantity').toggleClass('disabled', newValue == 1);
        $(this).closest('.product-detail').find('.btn-increase-quantity').toggleClass('disabled', newValue >= maxValue);
        $qtySelector.val(newValue);
        var url = withoutQty + '&quantity=' + newValue;
        $qtySelector.data('url', url);
        base.attributeSelect($qtySelector.data('url'), $productContainer);
    });
};

function updateAvailability() {
    $('body').on('product:updateAvailability', function (e, response) {
        $('div.availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available);

        // Only adds message for backorder
        if (response.isBackorder) {
            $('.availability-msg', response.$productContainer).empty().html(response.message);
            // Remove afterpay widget from view
            $('.prices-add-to-cart-actions div .afterpay-widget').addClass('d-none');
        } else {
            $('.availability-msg', response.$productContainer).empty();
            // Allow afterpay widget in view
            $('.prices-add-to-cart-actions div .afterpay-widget').removeClass('d-none');
        }

        if ($('.global-availability').length) {
            var allAvailable = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability')
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg').empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        }

        if (response.product.productBadge) {
            $(".js-product-badge")
                .removeClass('d-none')
                .addClass('d-block')
                .addClass('product-badge--' + response.product.productBadge)
                .text(response.product.productBadgeText);
        } else {
            $(".js-product-badge")
                .removeClass('d-block')
                .addClass('d-none')
                .removeClass(function (index, className) {
                    return (className.match(/(^|\s)product-badge--\S+/g) || []).join(' ');
                }
            );
        }

        /*
            Check to see if the product has the disablePurchase attribute marked, and if so, disable specific elements,
            else enable them. - disablePurchase is on the product model from the model file.

            The response object contains the product data from an ajax call made
         */
        if(response.product.disablePurchase) {
            $('div .toggle-pdp-cart-actions').addClass('d-none');
        } else {
            $('div .toggle-pdp-cart-actions').removeClass('d-none');
        }

        /*
            Check to see if the product has any promotional callout messages or tooltips, and if so,
            remove any existing ones out and re-add them to the DOM
         */
        $('div.toggle-pdp-cart-actions').find('div.promotion-callout').each(function () {
            $(this).remove();
        })
        if(response.product.promotions) {
            // Put any promotion callouts and tooltips back
            response.product.promotions.forEach(function (promotion) {
                updateProductPromotionCalloutMessagingByPromotion(promotion)
            })
        }

        // Update site vibes product data ID on variant selection
        sitevibes.updateSiteVibesProductDataId(response.product);
    });
};


/**
 * Updates any promotional messaging callouts or details on PDP for selected product
 * @param {Promotion} promotion - the basketModel to be evaluated
 */
function updateProductPromotionCalloutMessagingByPromotion(promotion) {

        // Make sure the promotion has enabled flag set
        if(promotion && promotion.enabled){

            // Get the first row and col in the dom that exists on PDP when page loads to be able
            // to put the elements back in the same place they were before.
            const $itemElement = $('div.toggle-pdp-cart-actions > div.row:first-child > div[class^="col-"]:first-child');

            // Handle details in tooltips
            let messageDetails = '';
            if(promotion.details) {
                messageDetails = `
                    <span class="info-icon">
                        <span class="icon" data-toggle="tooltip" title="${promotion.details}"><br />i</span>
                    </span>
                `
            }

            if(promotion.calloutMsg) {
                const messageDiv = `<div class="promotion-callout">${promotion.calloutMsg} ${messageDetails}</div>`;
                $itemElement.append(messageDiv);

                // Re-initializes elements that were removed and added back, but will not handle ones loaded in the
                // DOM already. You would need to destroy them and then add back if tooltips have been initialized
                // elsewhere, which they are by this point.
                // ALSO, html is not set to true here to reduce any XSS vectors and only show strings vs markup, even though
                // markup is allowed in the BM in the callout and details sections. This is currently how every other
                // bootstrap tooltip initialize is handled on the site
                $itemElement.find('span.icon').tooltip();
            }
        }
}

/**
 * Uses a class to toggle disabled so click events still work
 * Adds price to ATC
 */
function updateAddToCart() {
    $('body').on('product:updateAddToCart', function (e, response) {
        // update local add to cart (for sets)
        var disableATC = !response.product.readyToOrder || !response.product.available;
        $('button.add-to-cart', response.$productContainer).toggleClass(
            'disabled',
            (disableATC)
        )

        updateAddToCartEnableDisableOtherElements(disableATC);
        if (response.product.readyToOrder && response.product.available) {
            $('.atc-price').text(` - ${response.product.price.sales.formatted}`);
        }
    });
}

/**
 * Updates finalSale
 */
function updateAttribute() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.product-detail>.bundle-items').length) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
        } else if ($('.product-set-detail').eq(0)) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
        } else {
            $('.product-id').text(response.data.product.id);
            $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
        }
        
        $('.product-detail .final-sale-callout').toggleClass('d-none', !response.data.product.finalSale);
    });
}

/**
 * Updates PID at bottom of description
 */
function updateAttributesAndDetails() {
    $('body').on('product:statusUpdate', function (e, data) {
        var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

        $productContainer.find('.description-and-detail .product-attributes')
            .empty()
            .html(data.attributesHtml);

        if (data.shortDescription) {
            $productContainer.find('.description-and-detail .description')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .description .short-description.content')
                .empty()
                .html(data.shortDescription);
        } else {
            $productContainer.find('.description-and-detail .description')
                .addClass('hidden-xl-down');
        }

        if (data.longDescription) {
            $productContainer.find('.description-and-detail .details')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .details .content')
                .empty()
                .html(data.longDescription);
        } else {
            $productContainer.find('.description-and-detail .details')
                .addClass('hidden-xl-down');
        }

        $productContainer.find('.description-and-detail .pid')
            .empty()
            .html(data.id);
    });
}

function showSpinner () {
    // Overrides OOTB spinner
    $('body').on('product:beforeAddToCart', function () {
        $.spinner().stop();
    });
}

/**
 * Handle Scrolling Animations for Show More / Hide Desktop PDP Images
 * @param {boolean} isUpArrow - flag for if up or down arrow is being used
 * @param {int} imageGroupNumber - Image Group number the scrolling will be based off
 */
function showMoreScrollAnimations(isUpArrow, imageGroupNumber){
    if (isUpArrow) {
        // Quick Scroll so it does not jump to the bottom on collaspe
        $('html, body').animate({
            scrollTop: $(window).scrollTop() - ($('.image-group-' + (imageGroupNumber+1)).height() * $('.pdp-main-carousel .image-group-' + (imageGroupNumber+1)).length / 2)
        }, 0);
        $('.image-group-' + (imageGroupNumber+1)).addClass('d-lg-none');
        // Delayed Scroll for Cleaner scroll feel if user is below the images
        if ( $(window).scrollTop() >= $('.show-more-images').offset().top - $('.header-wrapper').height() - $('.image-group-0').height()) {
            setTimeout(function () { 
                $('html, body').animate({
                    scrollTop:  $('.show-more-images').offset().top - $('.header-wrapper').height() - $('.image-group-0').height()
                }, 500);
            }, 100)
        }
    } else {
        // Down Arrow Scrolling
        // Scroll to new images being shown
        var scrollToPosition = $('.pdp-main-carousel .image-group-' + imageGroupNumber).first().offset().top - $('.header-wrapper').height();
        $('html, body').animate({
            scrollTop: scrollToPosition
        }, 500);
        $(window).trigger('scroll');
    }
}

/**
 * Handle Arrow functionality for Show / Hide More Images on the Desktop PDP
 * @param {boolean} isUpArrow - flag for if up or down arrow is being used
 */
function showMoreArrowHandler(isUpArrow) {
    var arrowElm = isUpArrow ? $('.show-more-images-up-arrow') : $('.show-more-images-down-arrow')
    var inverseArrowElm = isUpArrow ? $('.show-more-images-down-arrow') : $('.show-more-images-up-arrow');
    var imageGroupNumber = parseInt(arrowElm.attr('data-group-to-show'));
    $('.image-group-' + imageGroupNumber).removeClass('d-lg-none');
    arrowElm.addClass('show-more-images-arrow-disabled');
    inverseArrowElm.removeClass('show-more-images-arrow-disabled');
    showMoreScrollAnimations(isUpArrow, imageGroupNumber);
}

/**
 * Init Function for Arrow Listeners for Show / Hide More Images on the Desktop PDP
 */
function initShowMoreImages() {
    $(document).on('click', '.show-more-images-controls .show-more-images-up-arrow', function (e) {
        e.preventDefault();
        showMoreArrowHandler(true);
       
    });
    $(document).on('click', '.show-more-images-controls .show-more-images-down-arrow', function (e) {
        e.preventDefault();
        showMoreArrowHandler(false);
    });
}

/**
 *  Init function to force tab index of -1 on elements with the ah-force-no-focus class
 */
function initForceNoFocus() {
    var $forceNoFocusElements = $('.ah-force-no-focus');
    if ($forceNoFocusElements.length > 0) {
        $forceNoFocusElements.each(function () {
            $(this).attr('tabindex', '-1');
        });
    }
}

var exportDetails = $.extend({}, detail, {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },
    addToCart: base.addToCart,
    availability: availability,
    disableAlerts: disableAlerts,
    pdpImageCarousel: pdpImageCarousel,
    productZoomListeners: base.productZoomListeners,
    selectVariation: tile.selectVariation,
    toggleShare: toggleShare,
    updateAddToCart: updateAddToCart,
    updateAttribute: updateAttribute,
    updateAttributesAndDetails: updateAttributesAndDetails,
    updateAvailability: updateAvailability,
    showSpinner: showSpinner,
    initShowMoreImages: initShowMoreImages
});

module.exports = exportDetails;
